<template>
  <div class="previous" @click="$emit('click')">
    <div class="previous-button">
        <img class="icon"
             v-if="checkIfThemeIsActive(availableThemes.Kabel24)"
             :src="publicImage('themes/kabel24/chevron-down-primary.svg')"
             alt="chevron_left"
             :class="getActiveTheme"
        />
        <img v-else class="icon" :src="publicImage('themes/elektramat/arrow-blue-left.svg')" alt=""/>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "BackButton",

  computed: {
    ...mapGetters({
      checkIfThemeIsActive: 'theme/checkIfThemeIsActive',
      getActiveTheme: 'theme/getActiveTheme',
      availableThemes: 'theme/getAvailableThemes'
    }),
  },
}
</script>

<style scoped lang="scss">
.previous {
  display: flex;
  align-items: center;
  position: relative;
  padding-right: 16px;
  margin-right: 16px;
  border-right: 1px solid $gray-100;
}

.previous-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 10px;
  border: 1px solid var(--configurator-primary);
  cursor: pointer;

  .icon {
    transform: translateX(-1px);
    max-height: 16px;

    &.kabel-24 {
      transform: rotate(90deg);
    }
  }
}
</style>
